import { ProductScreenshot } from 'components/ProductScreenshot';
import Link from 'components/Link';
import * as React from 'react';
export default {
  ProductScreenshot,
  Link,
  React
};